import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getPortfolioProjectBySlug } from "@/data/portfolioProjects";
import { getPortfolioDemo } from "@/pages/portfolio/demos";
import {
  DEFAULT_BRAND_WEB_VARIANT,
  getBrandWebVariant,
  isValidBrandWebVariant,
} from "@/pages/portfolio/demos/brandWebVariants";
import "./PortfolioDemoPage.css";

export default function PortfolioDemoPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const embed = searchParams.get("embed") === "1";
  const variantParam = searchParams.get("variant");
  const variant = slug === "brand-web" && isValidBrandWebVariant(variantParam)
    ? variantParam
    : slug === "brand-web"
      ? DEFAULT_BRAND_WEB_VARIANT
      : undefined;
  const project = getPortfolioProjectBySlug(slug);
  const Demo = getPortfolioDemo(slug);
  const variantMeta = slug === "brand-web" ? getBrandWebVariant(variant) : null;

  if (!project || !Demo) {
    return (
      <div className="pf-demo-page" style={{ display: "grid", placeItems: "center", color: "rgba(255,255,255,.6)" }}>
        <div style={{ textAlign: "center" }}>
          <p>데모를 찾을 수 없습니다.</p>
          <Link to={{ pathname: "/", hash: "portfolio" }} className="pf-demo-page__back" style={{ marginTop: "1rem" }}>
            <ArrowLeft size={16} />
            포트폴리오로 돌아가기
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`pf-demo-page${embed ? " pf-demo-page--embed" : ""}`}
      data-testid="portfolio-demo-page"
      style={{ "--pf-accent": project.accent }}
    >
      {!embed && (
        <div className="pf-demo-page__toolbar">
          <Link to={`/portfolio/${slug}`} className="pf-demo-page__back">
            <ArrowLeft size={16} aria-hidden="true" />
            프로젝트 설명 보기
          </Link>
          <span className="pf-demo-page__label">
            {project.title}
            {variantMeta ? ` · ${variantMeta.label}` : ""} · 미리보기
          </span>
        </div>
      )}
      <Demo accent={project.accent} embed={embed} variant={variant} />
    </div>
  );
}
